export enum eOrder {
  CLEARFASTTRACKORDER = 'CLEARFASTTRACKORDER',
  UPDATE_ORDER = 'UPDATEORDER',
  UPDATE_WORK = 'UPDATEWORK',
  UPDATE_PREVIOUS_ORDER = 'UPDATEPREVIOUSORDER',
  CLEAR_PREVIOUS_ORDER = 'CLEARPREVIOUSORDER',
  CLEAR_ORDER = 'CLEARORDER',
  CLEAR_WORK = 'CLEARWORK',
}
